import { connect } from 'react-redux'
import Select from 'react-select'
import at from 'lodash/at'
import throttle from 'lodash/throttle'
import isEmpty from 'lodash/isEmpty'
import uniqBy from 'lodash/uniqBy'
import { fetchTechniciansForLocation } from '../../actions/technicians'
import { setFiltersLoading, setCalendarFiltersForArea } from '../../actions/calendar-filters'
import { searchAreasByLocation, setCurrentSearch } from '../../actions/areas'
import { getAreasBySearch } from '../../selectors/area-selectors'

const mapStateToProps = (state, ownProps) => {
  const locationId = ownProps.locationId

  if (!locationId || !state.pagination.areasByLocation[locationId]) return { options: [] }

  let areas = getAreasBySearch(state, ownProps)
  if (ownProps.value !== null && !isEmpty(ownProps.value + '')) {
    areas.push(state.areas[ownProps.value])
    areas = uniqBy(areas, 'id')
  }

  const options = areas.map((area) => (
    {
      value: area.id,
      label: area.name
    }
  ))

  const { isLoading = false } = state.calendarFilters

  return {
    options,
    isLoading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.locationId

  const throttledSearch = throttle(
    () => dispatch(
      searchAreasByLocation(params)
    ), 250
  )

  let params = {
    locationId: id,
    searchQuery: '',
    nextPage: false
  }

  return {
    onChange (item) {
      const areaId = item ? item.value : null

      dispatch(setFiltersLoading(true))
        .then(() => { if (areaId) dispatch(fetchTechniciansForLocation(id)) })
        .then(() => dispatch(setCalendarFiltersForArea(areaId)))
        .then(() => ownProps.onChange(item))
        .then(() => dispatch(setFiltersLoading(false)))
    },
    onInputChange (search) {
      params.searchQuery = search
      params.nextPage = false
      dispatch(setCurrentSearch(search))
        .then(() => throttledSearch())
    },
    onMenuScrollToBottom (test) {
      params.nextPage = true
      dispatch(searchAreasByLocation(params))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/calendar/select-area-container.js